import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, publishLast, refCount, take } from 'rxjs/operators';
import { Validation, ContractType, PersonType } from '../../models';
import { ErrorMessage, CssClass } from '../../constants';
import { GtmDatalayerUiService } from '../gtm-datalayer/gtm-datalayer-ui.service';

@Injectable({
  providedIn: 'root'
})
export class GenderValidationService {
  constructor(private gtmDataLayerUiService: GtmDatalayerUiService) {

  }

  genderValidSubject: Subject<Validation> = new Subject<Validation>();
  genderValid$ = this.genderValidSubject.asObservable();
  private error: Validation = new Validation();
  isInValid(contractType: ContractType): boolean {
    let validation = this.genderValidation(contractType.policyHolder)
    this.setError(validation);
    return validation.isInValid;
  }
  private genderValidation(person: PersonType[]): Validation {
    let validation: Validation = new Validation();
    validation.isInValid = false;
    if (person.length == 0 || person[0].gender == null) {
      validation.isInValid = true;
      validation.errorCss = CssClass.error;
      this.gtmDataLayerUiService.setCjError(ErrorMessage.gender)
    }
    return validation;
  }
  setError(error: Validation) {
    this.genderValidSubject.next(error);
  }
}
